import { render, staticRenderFns } from "./pay25y.vue?vue&type=template&id=6563bebf&scoped=true&"
import script from "./pay25y.vue?vue&type=script&lang=js&"
export * from "./pay25y.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6563bebf",
  null
  
)

export default component.exports